import React from 'react'
import classNames from 'classnames'
import { node, oneOfType, string, object, array } from 'prop-types'

const Row = ({ children, className }) => (
  <tr
    className={classNames(
      'sw-table-row',
      'border-t border-haze',
      'bg-cloudWhite, hover:bg-haze',
      className
    )}
  >
    {children}
  </tr>
)

Row.displayName = 'Row'

Row.propTypes = {
  /** Component's children */
  children: node,
  /** Custom className */
  className: oneOfType([string, object, array])
}

export default Row
